import { getFullFieldPath } from '../../utils';

import { AU_TFN_TAB_KEY } from './constants';

export const getFullAuTfnPath = (fieldId: string): string => getFullFieldPath(AU_TFN_TAB_KEY, fieldId);
